// Link resolver for Prismic documents
// Used by gatsby-plugin-prismic-previews PrismicPreviewProvider
// Paths must have trailing slashes to match Gatsby v5's trailingSlash: "always" default
exports.linkResolver = (doc) => {
  switch (doc.type) {
    case 'home_page':
      return '/';
    case 'about_page':
      return '/about/';
    case 'contact_page':
      return '/contact/';
    case 'journal_entry':
      return '/news/';
    case 'project':
      return `/projects/${doc.uid}/`;
    case 'projects_portal':
      return '/projects/';
    case 'projects_under_construction':
      return '/under-construction/';
    case 'under_construction':
      return `/under-construction/${doc.uid}/`;
    default:
      return '/';
  }
};
